export default {"src":"/_next/static/media/pinterest.d1f4e703.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};